export default "__VITE_ASSET__C9PEqUV1__"